import React, { useState, useMemo } from "react";

export default function ViccesFoglalas() {
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [monthOffset, setMonthOffset] = useState(0);

  const reasons = [
    "Sétáltatom a macskát 🐈",
    "Dorkával leszek 💕",
    "OTP party 🎉",
    "OTP csapatépítő 🏢",
    "Fröccsözni fogok épp 🍷",
    "Balatonon leszek 🌊",
    "Netflix és pihi 😴",
    "A Hold állása épp nem megfelelő 🌕",
  ];

  const currentMonthDays = useMemo(() => {
    const today = new Date();
    today.setMonth(today.getMonth() + monthOffset);
    const year = today.getFullYear();
    const month = today.getMonth();
    const first = new Date(year, month, 1);
    const last = new Date(year, month + 1, 0);

    const arr = [];
    for (let d = first; d <= last; d.setDate(d.getDate() + 1)) {
      arr.push(new Date(d));
    }
    return arr;
  }, [monthOffset]);

  function formatDate(d) {
    return d.toLocaleDateString("hu-HU", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  }

  function getMonthName(offset) {
    const now = new Date();
    now.setMonth(now.getMonth() + offset);
    return now.toLocaleDateString("hu-HU", { month: "long", year: "numeric" });
  }

  function handleDayClick(day) {
    setSelected(day);
    setModalOpen(true);
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-100 via-pink-100 to-indigo-100 p-6 flex items-center justify-center font-sans">
      <div className="max-w-3xl w-full bg-white/80 backdrop-blur-md rounded-3xl shadow-2xl p-8 border border-white/40">
        {/* Header */}
        <header className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-4xl font-extrabold text-gray-800 tracking-tight">
              Bence booking
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Kérlek válassz a szabad időpontjaim közül. 😊
            </p>
          </div>
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-semibold bg-red-100 text-red-800 animate-bounce shadow-sm">
            🔥 100% foglalt
          </span>
        </header>

        {/* Month Selector */}
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={() => setMonthOffset((prev) => prev - 1)}
            className="px-3 py-1.5 rounded-full bg-white shadow hover:bg-gray-50 active:scale-95 transition"
          >
            ←
          </button>
          <h2 className="text-xl font-semibold capitalize text-gray-700">
            {getMonthName(monthOffset)}
          </h2>
          <button
            onClick={() => setMonthOffset((prev) => prev + 1)}
            className="px-3 py-1.5 rounded-full bg-white shadow hover:bg-gray-50 active:scale-95 transition"
          >
            →
          </button>
        </div>

        {/* Days Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-3">
          {currentMonthDays.map((d) => (
            <button
              key={d.toISOString()}
              onClick={() => handleDayClick(d)}
              className="p-4 rounded-2xl border border-dashed border-gray-300 bg-white/70 hover:bg-red-50 hover:scale-[1.03] hover:shadow transition-all duration-200 cursor-pointer group"
            >
              <div className="text-sm font-semibold text-gray-800 group-hover:text-red-600">
                {formatDate(d)}
              </div>
              <div className="text-xs text-red-600 mt-1 flex items-center gap-1 justify-center">
                <span className="animate-pulse">⛔</span> Foglalt
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <footer className="mt-8 flex flex-col sm:flex-row items-center justify-between text-sm text-gray-500 gap-2">
          <div>© Bence booking — 2025</div>
          <div className="italic text-center">
            Sajnos minden időpont foglalt — de ha nagyon fontos, próbáld meg
            jövő nyáron! 🌴
          </div>
        </footer>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={() => setModalOpen(false)}
          />
          <div className="relative z-10 max-w-md w-full bg-white rounded-3xl shadow-xl p-6 border border-gray-100 animate-in fade-in duration-200">
            <h2 className="text-2xl font-bold mb-2 text-red-700">
              Már foglalt! 😢
            </h2>
            <p className="text-gray-700 mb-4">
              A választott nap ({formatDate(selected)}) sajnos már foglalt.
            </p>

            <div className="mb-5 p-4 rounded-xl bg-red-50 border border-red-100 text-gray-700 shadow-inner">
              <p className="text-sm">
                <strong>Indok:</strong>{" "}
                <em>{reasons[Math.floor(Math.random() * reasons.length)]}</em>
              </p>
            </div>

            <button
              onClick={() => setModalOpen(false)}
              className="w-full px-5 py-2 rounded-xl bg-amber-400 text-white font-semibold shadow hover:bg-amber-500 active:scale-95 transition"
            >
              Rendben 😢
            </button>

            <div className="mt-4 text-xs text-gray-400 text-center">
              Tipp: Próbáld meg a jövő évet... hátha akkor 😊
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
